module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch1_20210921004149_T.101fd90f.jpg";